module.exports = __webpack_public_path__ + "img/my_learning_no_results.452e43d4.png";